import { render, staticRenderFns } from "./KPIPendingChangesBadge.vue?vue&type=template&id=65577064&scoped=true"
import script from "./KPIPendingChangesBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./KPIPendingChangesBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./KPIPendingChangesBadge.vue?vue&type=style&index=0&id=65577064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65577064",
  null
  
)

export default component.exports